import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { KButton, ButtonTheme } from "@kyburz/kdesign-system";

const useStyle = makeStyles(() => ({
  root: {
    marginTop: "16px",
    minHeight: "100px",
    padding: "16px 24px 16px 24px",
    backgroundColor: "white",
    borderRadius: 4,
  },
}));

interface Props {
  size: "small" | "regular" | "large" | "xlarge";
  children: React.ReactNode;
  primaryCTAText: string;
  primaryCTAonClick: Function | any;
  primaryCTAColor: ButtonTheme;
  secondaryCTAText?: string;
  secondaryCTAonClick?: Function | any | null;
  dangerCTAText?: string;
  dangerCTAonClick?: Function | any | null;
  disabled?: boolean;
}

const KFormBackground = ({
  size,
  children,
  primaryCTAText = "Save",
  primaryCTAonClick,
  primaryCTAColor = "primary",
  secondaryCTAText = "",
  secondaryCTAonClick = undefined,
  dangerCTAText = "",
  dangerCTAonClick = undefined,
  disabled = false,
}: Props) => {
  const classes = useStyle();
  const sizes = { small: 300, regular: 500, large: 800, xlarge: 1100 };

  return (
    <div className={classes.root} style={{ width: sizes[size] }}>
      {children}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          {dangerCTAonClick !== undefined ? (
            <KButton
              children={dangerCTAText}
              theme="danger"
              size="medium"
              onClick={dangerCTAonClick}
              style={{}}
            />
          ) : null}
        </div>
        <div style={{marginTop: 16}}>
          {secondaryCTAonClick !== undefined ? (
            <KButton
              children={secondaryCTAText}
              theme="secondary"
              size="medium"
              onClick={secondaryCTAonClick}
              style={{ display: "inline-block", marginRight: "16px" }}
            />
          ) : null}
          <KButton
            children={primaryCTAText}
            theme={primaryCTAColor}
            size="medium"
            onClick={primaryCTAonClick}
            style={{ display: "inline-block" }}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default KFormBackground;
